// @ts-nocheck
import { get, put } from './utils/api/index';
const API_URL = (process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768').trim();
const NOTIFICACOES_URL = new URL('/api/v1/notificacoes', API_URL).toString();
const NOTIFICACOES_MODULO = (process.env.REACT_APP_NOTIFICACOES_MODULO || 'Descarga').trim();
const buildListQuery = (filters = {}) => {
    const queryParams = new URLSearchParams();
    if (NOTIFICACOES_MODULO) {
        queryParams.append('Modulo', NOTIFICACOES_MODULO);
    }
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    return queryParams.toString();
};
/**
 * Lista notificações do usuário (SyncTransben).
 * @param {Record<string, any>} filters
 */
export const getNotificacoes = async (filters = {}) => {
    const query = buildListQuery(filters);
    const url = query ? `${NOTIFICACOES_URL}?${query}` : NOTIFICACOES_URL;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Marca uma notificação como lida.
 * @param {number|string} id
 */
export const marcarNotificacaoComoLida = async (id) => {
    await put(`${NOTIFICACOES_URL}/${id}/ler`);
};
/**
 * Marca todas as notificações como lidas (escopo opcional por módulo via query).
 */
export const marcarTodasNotificacoesComoLidas = async () => {
    const query = NOTIFICACOES_MODULO ? `?Modulo=${encodeURIComponent(NOTIFICACOES_MODULO)}` : '';
    await put(`${NOTIFICACOES_URL}/ler-todas${query}`);
};
/**
 * Marca uma notificação como lida (alias usado pela topbar).
 * @param {number|string} id - ID da notificação ou 'todas'
 */
export const marcarComoLida = async (id) => {
    if (id === 'todas') {
        await marcarTodasNotificacoesComoLidas();
        return;
    }
    await marcarNotificacaoComoLida(id);
};
